import { HubConnectionBuilder, HubConnection } from '@microsoft/signalr';
import { Dispatch } from 'redux';
import { connect, disconnect, addConnection, deleteConnection } from '../contexts/slices/signalr';
import { newToast } from '../components';
import { formatMessage } from 'devextreme/localization';
const configUrl = '/config.json';

let connection: HubConnection | null = null;

const getUrl = () => {
    return fetch(configUrl)
        .then(response => response.json())
        .then(config => config.singnalRUrl);
}
const urlPromise = getUrl();
export async function startSignalRConnection(dispatch: Dispatch) {
    if (connection) {
        return;
    }
    const url = await urlPromise;
    connection = new HubConnectionBuilder()
        .withUrl(`${url}/dataChangeHub`)
        .withAutomaticReconnect()
        .build();
    try {
        await connection.start().catch(err => {
        });
        const connectionId = connection.connectionId;
        if (!connectionId) {
            return
        }
        console.log('Conectado web socket dataChange....')

        connection.onreconnected(()=>{
            dispatch(connect(connectionId))
            newToast('SUCCESS',formatMessage("conexStatusOk"),3)
        })

        connection.onreconnecting(() => {
            console.log('Intentando restablecer la conexión con el servidor...');
            newToast('ERROR',formatMessage("conexStatusError"),3)
            dispatch(disconnect())
        });

        dispatch(connect(connectionId))
        addConnection(connectionId, connection)
    } catch (error) {
        newToast('ERROR', 'Se ha perdido la conexión', 5);
    }
}


export async function stopSignalRConnection(dispatch: Dispatch) {
    if (!connection) {
        console.log('null conex')
        return;
    }
    try {
        dispatch(disconnect());
        const connectionId = connection.connectionId;
        if (!connectionId) {
            return
        }
        deleteConnection(connectionId)
        await connection.stop();
        connection = null;
        console.log('Desconectado web socket dataChange...')
    } catch (error) {
        newToast('ERROR', 'Error al desconectar', 5);
    }
    finally {
        startSignalRConnection(dispatch)
    }
}
